module.exports = __webpack_public_path__ + "img/Blog5.3.60a3d18e.png";